module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "id-validate"
  }, [_c('form', {
    staticClass: "s-form"
  }, [_c('div', {
    staticClass: "s-form-row validated-info"
  }, [_c('label', {
    staticClass: "s-form-label"
  }, [_vm._v("\n        已验证" + _vm._s(_vm.v_type == 'email' ? '邮箱' : '手机') + "：\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "s-form-info"
  }, [_c('span', {
    staticClass: "validated-item"
  }, [_vm._v(_vm._s(_vm.info))]), _vm._v(" "), (_vm.switch_enabled) ? _c('a', {
    staticClass: "blue",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.switchToPhoneValidate
    }
  }, [_vm._v("更换为" + _vm._s(_vm.v_type != 'email' ? '邮箱' : '手机') + "验证")]) : _vm._e()])]), _vm._v(" "), _c('send_code', {
    attrs: {
      "type": _vm.v_type,
      "request": _vm.request,
      "pwd_type": _vm.type,
      "modify_type": _vm.modify_type
    },
    on: {
      "errorResult": _vm.errorResult
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "s-form-btnrow"
  }, [_c('button', {
    staticClass: "s-button submit s-btn-warning",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v(_vm._s(_vm.btn_text))]), _vm._v(" "), _vm._m(0)])], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "options": _vm.options
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "button-tips"
  }, [_vm._v("无法验证身份？进行 "), _c('a', {
    staticClass: "blue",
    attrs: {
      "target": "_blank",
      "href": "//wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDgwMjAwMV80NDMwOTZfODAwODAyMDAxXzJf"
    }
  }, [_vm._v("账户申诉")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6c70ef20!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/validation/id_validate.vue
// module id = k/HJ
// module chunks = 15